import { Routes } from "@angular/router";
import { OktaAuthGuard, OktaCallbackComponent } from "@okta/okta-angular";
import { PageLicenseComponent, PageLogInteractionsComponent, PageLogSystemComponent, PageLogChangesComponent, PageLicenseRolesComponent, PageRoleTemplatesComponent, PageUserPermissionComponent, PageUserLicenseComponent, InstanceListComponent } from "./features/admin";
import { UsersComponent, CompaniesComponent, ModulesComponent } from "./features/admin/components";
import { HomePageComponent, LoginComponent, DashboardComponent, PageNotFoundComponent, PageNotAuthorizedComponent, PageNoLicenseComponent } from "./modules/fwcore";

export const routes: Routes = [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      {
        path: 'home',
        component: HomePageComponent,
        canActivate: [OktaAuthGuard],
      },
      { path: 'login', component: LoginComponent },
      { path: 'login/callback', component: OktaCallbackComponent },
      {
        path: 'admin/license',
        component: PageLicenseComponent,
        canActivate: [OktaAuthGuard],
      },
      {
        path: 'admin/user',
        component: UsersComponent,
        canActivate: [OktaAuthGuard],
      },
      {
        path: 'admin/company',
        component: CompaniesComponent,
        canActivate: [OktaAuthGuard],
      },
      {
        path: 'admin/module',
        component: ModulesComponent,
        canActivate: [OktaAuthGuard],
      },
      {
        path: 'admin/pagelog',
        component: PageLogInteractionsComponent,
        canActivate: [OktaAuthGuard],
      },
      {
        path: 'admin/systemlog',
        component: PageLogSystemComponent,
        canActivate: [OktaAuthGuard],
      },
      {
        path: 'admin/changelog',
        component: PageLogChangesComponent,
        canActivate: [OktaAuthGuard],
      },
      {
        path: 'admin/role',
        component: PageLicenseRolesComponent,
        canActivate: [OktaAuthGuard],
      },
      {
        path: 'admin/role-template',
        component: PageRoleTemplatesComponent,
        canActivate: [OktaAuthGuard],
      },
      {
        path: 'admin/user/permission',
        component: PageUserPermissionComponent,
        canActivate: [OktaAuthGuard],
      },
      {
        path: 'admin/user/license',
        component: PageUserLicenseComponent,
        canActivate: [OktaAuthGuard],
      },
      {
        path: 'admin/instance',
        component: InstanceListComponent,
        canActivate: [OktaAuthGuard],
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [OktaAuthGuard],
      },
      { path: 'error/404', component: PageNotFoundComponent },
      { path: 'error/not-authorized', component: PageNotAuthorizedComponent },
      { path: 'not-authorized', redirectTo: 'error/not-authorized' },
      { path: 'no-license', component: PageNoLicenseComponent },
      { path: '**', redirectTo: 'error/404' },
    ]